import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

import Config from "@app/config";

type PromotionModalId = "trial_extension_on_purchase";

const DEFAULT_PAGE_TITLE = "Read AI";

interface UiStateValues {
  forceDesktopView: boolean;
  pageTitle: string;
  promotionRedeemedModalId: PromotionModalId | null;
}

interface UiState extends UiStateValues {
  setForceDesktopView: (force: boolean) => void;
  setPageTitle: (title: string) => void;
  setPromotionRedeemedModalId: (id: PromotionModalId | null) => void;
}

const DEFAULT_STATE: UiStateValues = {
  forceDesktopView: !Config.flags.enableMobileNav,
  pageTitle: DEFAULT_PAGE_TITLE,
  promotionRedeemedModalId: null,
};

const useUiStore = createWithEqualityFn<UiState>(
  (set) => ({
    ...DEFAULT_STATE,
    setForceDesktopView: (forceDesktopView) => set({ forceDesktopView }),
    setPageTitle: (pageTitle) => set({ pageTitle }),
    setPromotionRedeemedModalId: (promotionRedeemedModalId) =>
      set({ promotionRedeemedModalId }),
  }),
  shallow
);

export default useUiStore;
